export default __webpack_public_path__ + "static/media/FR.95747314.svg";